import { arc, pie, select } from 'd3'
import { AuthorInterface } from '../../../interface/author.interface'
import { getInitial } from '../../../utils/get-author-initials'

const appendCenterAuthorInputsUtil = (
  svgContainer: any,
  authorsInput: AuthorInterface[],
  {
    width,
    height,
  }: {
    width: number
    height: number
  },
) => {
  const dataAuthorInput = Array(authorsInput.length).fill(50)
  const arcGenerator = arc().innerRadius(0).outerRadius(50)

  const pieCenter = pie()
  if (dataAuthorInput.length === 3) {
    pieCenter.startAngle(-Math.PI / 6).endAngle(2 * Math.PI - Math.PI / 6)
  }
  pieCenter.value((d: any) => d)

  const arcs = pieCenter(dataAuthorInput)
  const pathsA = svgContainer
    .selectAll('path')
    .data(arcs)
    .enter()
    .append('path')
    .attr('transform', `translate(${width / 2}, ${height / 2})`)
    .attr('d', arcGenerator)
    .style('fill', '#F7F7F7')
    .style('stroke', '#FFFFFF')
    .style('stroke-width', '2px')

  function getTextCoordinates(
    startAngle: number,
    endAngle: number,
    deviation: number,
  ) {
    const deviationInRadians = (deviation / 360) * (2 * Math.PI)
    const midAngle = (startAngle + endAngle) / 2 + deviationInRadians
    const halfRadius = 25
    const x = Math.cos(midAngle) * halfRadius
    const y = Math.sin(midAngle) * halfRadius
    return { x, y }
  }

  let deviation = 0

  if (dataAuthorInput.length === 3) {
    deviation = 25
  } else if (dataAuthorInput.length === 2) {
    deviation = 90
  }

  pathsA.each((d: any, i: number) => {
    const textCoords =
      dataAuthorInput.length === 1
        ? { x: 0, y: 0 }
        : getTextCoordinates(d.startAngle, d.endAngle, deviation)

    svgContainer
      .append('text')
      .text(getInitial(authorsInput[i].name))
      .attr('x', width / 2 + textCoords.x)
      .attr('y', height / 2 + textCoords.y)
      .attr('text-anchor', 'middle')
      .attr('style', 'overflow: visible')
      .attr('dominant-baseline', 'middle')
      .attr('font-size', 20)
      .attr('font-family', 'sans-serif')
      .attr('fill', 'black')
  })
}

export default appendCenterAuthorInputsUtil
